import React, { useEffect } from 'react';
import clsx from 'clsx';
import { IOption, deprecateProp } from '@hse-design/core';

import { ISelectProps, Select, SelectVariant } from '../Select';

export type NoMultiple<T> = T extends { multiple: true } ? never : T;

export type HeaderLanguageSelectProps = Partial<NoMultiple<ISelectProps>> & {
  /**
   * @deprecated используйте options
   */
  languages?: IOption[];
  /**
   * @deprecated используйте value
   */
  currentLanguage?: string | null;
};

export function HeaderLanguageSelect({
  languages,
  currentLanguage,
  className,
  ...props
}: HeaderLanguageSelectProps) {
  useEffect(() => {
    if (currentLanguage)
      deprecateProp(
        'currentLanguage',
        'Используйте проп value',
        HeaderLanguageSelect
      );
    if (languages)
      deprecateProp(
        'languages',
        'Используйте проп options',
        HeaderLanguageSelect
      );
  }, [currentLanguage, languages]);
  return (
    <Select
      className={clsx('hse-HeaderLanguageSelect', className)}
      clearable={false}
      options={languages}
      value={currentLanguage || null}
      variant={SelectVariant.borderless}
      width={72}
      {...props}
    />
  );
}
